import React, { memo, useCallback } from 'react';

import { Col, Row } from 'antd';

import { Field } from 'formik';
import { SelectProduct } from 'v2/components/Shared/FormFields/SelectProduct';

interface IProps {
  onChange?: (product_id: number) => void;
  onConfirm?: (product_id: number) => void;
}

const Fields = memo(({ onChange, onConfirm }: IProps) => {
  const handleOnConfirm = useCallback(
    (product: number) => {
      onChange?.(product);
      onConfirm?.(product);
    },
    [onChange, onConfirm]
  );

  return (
    <Row justify='space-between'>
      <Col span={24}>
        <Field
          id='product_id'
          name='product_id'
          onConfirm={handleOnConfirm}
          single
          fullWidth
          label='Produtos'
          component={SelectProduct}
          endpoint='reports/filter-all-products'
        />
      </Col>
    </Row>
  );
});

export default Fields;
